import React from "react";
import ListItem from "@material-ui/core/ListItem";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import {toDollars} from "../../utils";
import PropTypes from "prop-types";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    listItem: {
        justifyContent: 'space-between'
    },
    nested: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),

    },
}))
function ChargedItem({label, price, divider, nested}) {
    const cls = useStyles();
    const classes = !!nested ? [cls.listItem, cls.nested] : [cls.listItem];
    const textColor = !!nested ? 'textSecondary' : 'textPrimary';
    return <ListItem className={classes.join(' ')} divider={divider} dense={!!nested} disableGutters={!nested}>
        <Box><Typography variant='body1' color={textColor} data-cy="charge-line-item-text">{label}</Typography></Box>
        <Box><Typography variant='body1' color={textColor} data-cy="charge-line-item-value-text">{toDollars(price)}</Typography></Box>
    </ListItem>
}
ChargedItem.propTypes = {
    label: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    divider: PropTypes.bool,
    nested: PropTypes.bool
}
export default React.memo(ChargedItem);
